import classNames from 'classnames';

import MenuItemsSection from './components/MenuItemsSection';
import RewardsSection from './components/RewardsSection';
import FooterDescription from './components/FooterDescription';

import Props from './FooterMenu.types';
import classes from './FooterMenu.module.scss';

const FooterMenu = ({ menuItems, rewards, brands, apiVersion }: Props): JSX.Element => (
  <div
    className={classNames(classes.wrapper, {
      [classes.withoutRewards]: !rewards.length,
      [classes.withApiVersion]: !!apiVersion,
    })}
    data-nosnippet
  >
    <div className={classes.container}>
      {!!rewards.length && <RewardsSection rewards={rewards} />}
      {!rewards.length && <FooterDescription />}
    </div>
    <MenuItemsSection menuItems={menuItems} brands={brands} withoutContact={!rewards.length} apiVersion={apiVersion} />
  </div>
);

export default FooterMenu;
